/* Homepage-palette interiors: small, optional interactions using native browser APIs. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.fcv3-guide__tabs').forEach((list) => {
    const tabs = [...list.querySelectorAll('[data-fcv3-tab]')];
    const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
    if (tabs.length !== 2 || panels.some((panel) => !panel)) return;
    const select = (index, focus = false) => {
      tabs.forEach((tab, current) => {
        const active = current === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[current].hidden = !active;
      });
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(next, true);
      });
    });
    select(0);
  });

  const policyLinks = document.querySelector('[data-fcv3-policy-links]');
  if (policyLinks) {
    const headings = [...document.querySelectorAll('.shopify-policy__body h2')];
    if (headings.length) {
      headings.forEach((heading, index) => {
        heading.id ||= `PolicySection-${index + 1}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        policyLinks.append(link);
      });
      policyLinks.closest('.fcv3-policy-nav')?.classList.add('is-ready');
    }
  }

  if (reduced.matches) return;
  const parallax = [...document.querySelectorAll('[data-fcv3-parallax]')];
  let scrollFrame = 0;
  const updateParallax = () => {
    scrollFrame = 0;
    const middle = window.innerHeight / 2;
    for (const element of parallax) {
      const bounds = element.getBoundingClientRect();
      if (bounds.bottom < 0 || bounds.top > window.innerHeight) continue;
      const shift = Math.max(-24, Math.min(24, (middle - (bounds.top + bounds.height / 2)) * .045));
      element.style.setProperty('--fcv3-parallax', `${shift.toFixed(1)}px`);
    }
  };
  if (parallax.length) {
    updateParallax();
    window.addEventListener('scroll', () => {
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateParallax);
    }, { passive: true });
    window.addEventListener('resize', updateParallax, { passive: true });
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('[data-fcv3-tilt]').forEach((element) => {
      let pointerFrame = 0;
      let latest = null;
      element.addEventListener('pointermove', (event) => {
        latest = event;
        if (pointerFrame) return;
        pointerFrame = window.requestAnimationFrame(() => {
          pointerFrame = 0;
          const bounds = element.getBoundingClientRect();
          const x = ((latest.clientX - bounds.left) / bounds.width - .5) * 2;
          const y = ((latest.clientY - bounds.top) / bounds.height - .5) * 2;
          element.style.setProperty('--fcv3-tilt-x', `${(-y * 6).toFixed(2)}deg`);
          element.style.setProperty('--fcv3-tilt-y', `${(x * 6).toFixed(2)}deg`);
        });
      }, { passive: true });
      element.addEventListener('pointerleave', () => {
        element.style.setProperty('--fcv3-tilt-x', '0deg');
        element.style.setProperty('--fcv3-tilt-y', '0deg');
      });
    });
  }
})();
